import React from 'react'
import { COMMISSION, COMMISSION_LINK } from '../../helpers/constants'
import type { SectionProps } from './Section'
import Section from './Section'

const Component = (props: SectionProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const { currentSection, onToggle, section } = props
  return (
    <Section
      name={COMMISSION}
      title='How does commission work on Saatchi Art?'
      {...{
        currentSection,
        onToggle,
        section,
      }}
    >
      <p>
        If you sell an original artwork, Saatchi Art will take a 40% commission on the final sale
        price. If a promotional discount code is offered, the discount will be deducted from the
        price of the artwork and the 60/40 commission split will then be calculated, so that we are
        sharing the discount with you. Like all galleries, we offer promotional discounts from time
        to time as an incentive for new and returning collectors to explore the constantly updating
        selection of artwork on Saatchi Art. We know that offering promotions allows artists to gain
        the attention of collectors previously unaware of their work and a better chance to make
        future sales. With Saatchi Art’s low commission, only 40% compared to the 50% most galleries
        take, even with a promotional discount, you earn more selling your work with Saatchi Art.{' '}
        <a data-type='link' target='_blank' rel='noopener noreferrer' href={COMMISSION_LINK}>
          Learn More
        </a>
      </p>
    </Section>
  )
}

export default Component